import { useTranslation } from 'react-i18next';
import ArticleMeta from '../../types/ArticleMeta';
import dayjs from 'dayjs';
import isToday from 'dayjs/plugin/isToday';
import isYesterday from 'dayjs/plugin/isYesterday';

/* eslint-disable import-x/no-named-as-default-member */
dayjs.extend(isToday);
dayjs.extend(isYesterday);

/**
 * Groups articles by date to "today", "yesterday" and "older" groups. One or
 * more groups can be missing, if no articles are present for that date.
 */
export default function useGroupedNewsArticles(articles: ArticleMeta[]) {
  const { t } = useTranslation();

  const getDateLabel = (date: Date): string => {
    if (dayjs(date).isToday()) {
      return t('news.today');
    }

    if (dayjs(date).isYesterday()) {
      return t('news.yesterday');
    }

    return t('news.older');
  };

  return articles.reduce(
    (groups, article) => {
      const dateLabel = getDateLabel(new Date(article.releaseDate));

      if (!groups[dateLabel]) {
        groups[dateLabel] = [];
      }

      groups[dateLabel].push(article);
      return groups;
    },
    {} as Record<string, ArticleMeta[]>,
  );
}
